export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-8">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">联系我们</h2>
            <p className="mt-3 text-sm text-foreground-500">有建议或合作意向？欢迎联系我们</p>
          </div>

          <div className="max-w-2xl mx-auto bg-background-50 rounded-2xl p-6 md:p-10">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 text-center">
              <div className="flex flex-col items-center gap-2 p-4">
                <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center">
                  <i className="ri-mail-line text-primary-600 text-lg"></i>
                </div>
                <p className="text-sm font-semibold text-foreground-900">投稿邮箱</p>
                <p className="text-xs text-foreground-500">contact@pianduoduo.com</p>
              </div>
              <div className="flex flex-col items-center gap-2 p-4">
                <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center">
                  <i className="ri-wechat-line text-accent-600 text-lg"></i>
                </div>
                <p className="text-sm font-semibold text-foreground-900">官方微信</p>
                <p className="text-xs text-foreground-500">片多多影视</p>
              </div>
              <div className="flex flex-col items-center gap-2 p-4">
                <div className="w-12 h-12 rounded-xl bg-secondary-100 flex items-center justify-center">
                  <i className="ri-customer-service-2-line text-secondary-600 text-lg"></i>
                </div>
                <p className="text-sm font-semibold text-foreground-900">意见反馈</p>
                <p className="text-xs text-foreground-500">在线客服 9:00-21:00</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}